import React from "react";
import "./Main.css";
import Menu from "./Menu";
import Detail from "./Detail";
import Tools from "./Tools";
import Sakura from "../sakura/Sakura";

const Main = () => {

    return (
        <div className="main">
            {/*<div className="main-bg"/>*/}
            <Sakura />
            <Menu />
            <Detail />
            <Tools />
        </div>
    )
}

export default Main